import { useState } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/movies";

const tabs = [
  { key: "latest", label: "最新上映" },
  { key: "top", label: "高分佳作" },
  { key: "japan", label: "日系精选" },
];

export default function LatestMovies() {
  const [activeTab, setActiveTab] = useState("latest");

  const sorted = [...movies].sort((a, b) => b.publishDate.localeCompare(a.publishDate));

  let list = sorted;
  if (activeTab === "top") {
    list = [...movies].sort((a, b) => b.rating - a.rating);
  } else if (activeTab === "japan") {
    list = sorted.filter((movie) => movie.region === "日本");
  }

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-5">
          <div>
            <p className="font-label text-[11px] tracking-[0.26em] uppercase text-accent-500">
              Now Showing
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              最新影片推荐
            </h2>
            <p className="mt-2 text-xs md:text-sm text-foreground-500 max-w-[520px] leading-relaxed">
              持续更新的日韩情感电影片单，每部作品都附有完整的剧情简介与创作信息。
            </p>
          </div>

          <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-300/60 self-start lg:self-auto">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 rounded-full text-xs md:text-sm cursor-pointer transition-colors whitespace-nowrap ${
                  activeTab === tab.key
                    ? "bg-primary-500 text-foreground-950"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-7 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-8 md:gap-x-5">
          {list.slice(0, 8).map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center">
          <Link
            to="/category/recent"
            className="h-11 px-7 rounded-md border border-background-400/60 text-sm text-foreground-800 inline-flex items-center gap-2 cursor-pointer hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
          >
            浏览完整片库
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}